import ActionTypes from './actionTypes';

export const getServices = payload => ({
  type: ActionTypes.GET_SERVICES,
  payload
});

export const reset = () => ({ type: ActionTypes.RESET });
